module.exports = __webpack_public_path__ + "img/ccompany-honor-RoHS-20241023.53dda74c.jpg";